import type { PayloadAction } from "@reduxjs/toolkit";

import { createSlice } from "@reduxjs/toolkit";

import { signIn, register } from "../thunks/userThunks";

export interface UserState {
  error: null | string;
  id: string;
  loading: boolean;
  accessToken: string;
  customerDto: {
    role: string;
    email: string;
    id: string;
    firstname: string;
    lastname: string;
  };
  getStreamUser: {
    getStreamUserId: string;
    userToken: string;
  };
}
export interface ActionState {
  yoken: string;
  customerDto: {
    email: string;
    id: string;
    firstname: string;
    lastname: string;
  };
}

export interface LoginData {
  email: string;
  password: string;
}

const initialState: UserState = {
  loading: false,

  getStreamUser: {
    getStreamUserId: "",
    userToken: "",
  },
  error: null,
  id: "string",
  accessToken: "",
  customerDto: {
    role: "",
    email: "",
    id: "",
    firstname: "",
    lastname: "",
  },
};

export const userSlice = createSlice({
  extraReducers: (builder) => {
    builder.addCase(signIn.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder
      .addCase(signIn.fulfilled, (state, action: PayloadAction<UserState>) => {
        state.loading = false;
        const { customerDto, accessToken } = action.payload;
        console.log(action.payload);

        state.customerDto.email = customerDto.email;
        state.id = customerDto.id;
        state.accessToken = accessToken;
        state.customerDto.firstname = customerDto.firstname;
        state.customerDto.lastname = customerDto.lastname;
        localStorage.setItem("accessToken", action.payload.accessToken);
        localStorage.setItem(
          "user",
          JSON.stringify(action.payload.customerDto)
        );
        localStorage.setItem(
          "getStreamUser",
          JSON.stringify(action.payload.getStreamUser)
        );
      })
      .addCase(signIn.rejected, (state, action) => {
        state.loading = false;
        const errorMessage = action.payload?.toString() || "An error occurred";
        state.error = errorMessage;
        console.log(errorMessage);
      });

    builder.addCase(register.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      register.fulfilled,
      (state, action: PayloadAction<UserState>) => {
        state.loading = false;
        const { customerDto, accessToken, getStreamUser } = action.payload;
        console.log("getStreamUser", getStreamUser);

        state.customerDto.email = customerDto.email;
        state.id = customerDto.id;
        state.accessToken = accessToken;
        state.customerDto.firstname = customerDto.firstname;
        state.customerDto.lastname = customerDto.lastname;
        localStorage.setItem("accessToken", action.payload.accessToken);
        localStorage.setItem(
          "user",
          JSON.stringify(action.payload.customerDto)
        );
        localStorage.setItem(
          "getStreamUser",
          JSON.stringify(action.payload.getStreamUser)
        );
      }
    );
    builder.addCase(register.rejected, (state, action) => {
      state.loading = false;
      const errorMessage = action.payload?.toString() || "An error occurred";
      state.error = errorMessage;
      console.log(errorMessage);
    });
  },
  initialState,
  name: "user",
  reducers: {
    logout: () => {
      localStorage.removeItem("token");
      return initialState;
    },
  },
});

export const { logout } = userSlice.actions;

export default userSlice.reducer;
